const store = app.store;
import validatePermissions from '../../helpers/validatePermissions'

export default (permissions, redirect) => {
    return new Promise(async (resolve, reject) => {
        let pathRedirect = `${redirect}${window.location.search && window.location.search.length > 0 ? `${window.location.search}&` : "?"}redirect=${window.location.pathname}`;
        if (store.getters['rms_ui/auth/auth_loading']()) {
            //waiting for store to be initialized...;
            const watcher = store.watch(store.getters['rms_ui/auth/auth_loading'], async (val) => {
                watcher(); // stop watching
                let campaign_ids = app.activeMultiCampaigns ? app.activeMultiCampaigns.map(c => c.id) : [];
                let res = validatePermissions(permissions, campaign_ids);
                if (res.isValid) {
                    resolve(true);
                } else {
                    if(app.auth.isAuth && window.location.pathname != '/login'){
                        resolve(true);
                    }else{
                        reject({path: pathRedirect});
                    }
                }
            });
        } else {
            let campaign_ids = app.activeMultiCampaigns ? app.activeMultiCampaigns.map(c => c.id) : [];
            let res = validatePermissions(permissions, campaign_ids);
            if (res.isValid) {
                resolve(true);
            } else {
                if(app.auth.isAuth && window.location.pathname != '/login'){
                    resolve(true);
                }else{
                    reject({path: pathRedirect});
                }
            }
        }
    })
}